module.exports = __webpack_public_path__ + "static/img/back_bg.cfa46b60.png";